export default __webpack_public_path__ + "static/media/media_default.3b9b90b2.png";